import api from '@/lib/axios';

export interface Permission {
  id: string;
  action: string;
  resource: string;
  description: string | null;
}

export interface Role {
  id: string;
  name: string;
  description: string | null;
  companyId: string;
  rolePermissions: { permission: Permission }[];
  _count: { users: number };
}

export interface CreateRoleData {
  companyId: string;
  name: string;
  description?: string;
  permissionIds?: string[];
}

export interface UpdateRoleData {
  name?: string;
  description?: string;
  permissionIds?: string[];
}

export const rolesService = {
  async findByCompany(companyId: string): Promise<Role[]> {
    const response = await api.get(`/roles/company/${companyId}`);
    return response.data;
  },

  async getPermissions(): Promise<Permission[]> {
    const response = await api.get('/roles/permissions');
    return response.data;
  },

  async create(data: CreateRoleData) {
    const response = await api.post('/roles', data);
    return response.data;
  },

  async update(id: string, data: UpdateRoleData) {
    const response = await api.put(`/roles/${id}`, data);
    return response.data;
  },

  async remove(id: string) {
    const response = await api.delete(`/roles/${id}`);
    return response.data;
  },
};
